import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'; 
import { NavLink } from 'react-router-dom';
import { resetStart, resetStep, resetPerson, resetAddress, resetThirdParty, resetMailShip, resetExportImport, 
  resetCurrencyItem, resetCoinItem, resetOtherItem, resetReviewSign, resetReceipt } from '../actions';
import { TextField, Typography, Button, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Popup from 'reactjs-popup';
import logo from '../images/check.png';
import Needhelp from '../images/needhelp.jpg'
import NumberFormat from 'react-number-format';
import { SendEmail, downloadReceipt } from '../service/Receipt';
import Header from '../container/Header';
// import {QRCodeCanvas} from "qrcode.react";

// Shared button styles for easy global adjustments
const baseButtonSx = {
  ml: 1,
  mr: 1,
  width: 200,
};

const outlinedButtonSx = {
  ...baseButtonSx,
  color: "#324bb5",
  borderColor: "#324bb5",
  mb: { xs: 1, sm: 0 },
  '&:hover': {
    borderColor: '#1976d2',
    backgroundColor: 'rgba(50, 75, 181, 0.04)',
  },
};

const containedButtonSx = {
  ...baseButtonSx,
  backgroundColor: "#324bb5",
  mb: { xs: 1, sm: 0 },
  '&:hover': {
    backgroundColor: '#1976d2',
  },
};

function Confirmation(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const receipt = useSelector((state) => state.receipt)

  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [modalopen, setModalopen] = useState(true);
  const [errorText, setErrorText] = useState('');

    useEffect(() => {
      document.title = 'Confirmation | FinCEN Form 105 | CMIR, U.S. Customs and Border Protection';
    }, []); // Empty dependency array means it runs once on mount

  // constructor(props) {
  //   super(props);    
  //   this.state = {receipt: props.receipt, email: '', modalopen: true , errorText: '', isValidEmail: false};
  // }

  // static getDerivedStateFromProps(nextProps, prevState) {  
  //   if(nextProps.receipt !== prevState.receipt) {
  //     return { receipt: nextProps.receipt }
  //   } return null;        
  // }

  const handleChange = (event) => {
  // const handleChange = (name) => (event) => {
    // this.setState({ [name]: event.target.value })
    setEmail(event.target.value)
    let emailpattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/  
      if (emailpattern.test((event.target.value))===false){
        setIsValidEmail(false)
        setErrorText("Please enter a valid email Address")
      } else {
        setIsValidEmail(true)
        setErrorText("")
      }     
  };

  const clearAll = (event) => {
    dispatch(resetStep())
    dispatch(resetStart());
    dispatch(resetPerson());
    dispatch(resetAddress());
    dispatch(resetExportImport());
    dispatch(resetMailShip());
    dispatch(resetThirdParty());
    dispatch(resetCurrencyItem());
    dispatch(resetCoinItem());
    dispatch(resetOtherItem());
    dispatch(resetReviewSign());
    dispatch(resetReceipt());
  }

  const startOver = (event) => {
    clearAll();
    navigate('/');
  }

  const modalOpen = () => {
    setModalopen(true)
  }
  
  const emailConfirmation = () => {
    //const qrCodeCanvas = document.querySelector('canvas');
    //const qrCodeDataUri = qrCodeCanvas.toDataURL('image/png');
    const newReceipt = {
      ...receipt,
      //sigQrBase64:qrCodeDataUri
    };
    SendEmail(newReceipt, email);
    setModalopen(false)
  }

  const printReceipt = () => {
    var css = '@page { size: landscape; } @media print {body {-webkit-print-color-adjust: exact;}}',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

    style.type = 'text/css';
    style.media = 'print';

    if (style.styleSheet){
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);

    window.print();
  }

  const downloadPDF = () => {
    //const qrCodeCanvas = document.querySelector('canvas');
    //const qrCodeDataUri = qrCodeCanvas.toDataURL('image/png');
    // const newReceipt = {
    //   ...receipt,
      //sigQrBase64:qrCodeDataUri
    // };
    // this.setState ({receipt:newReceipt });
    downloadReceipt(receipt);
  }
    
  return (
    <Grid sx={{
      display: 'block',
      mb: '16px',
      minWidth: '300px',
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      backgroundSize: "cover",
      float: 'left',
      width: '100%',
    }} >
      {/* <center> */}
        <Header />
      <Grid container sx={{ padding: '6px 33px 7px 40px', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Grid>
          <Grid container sx={{ alignItems: 'flex-start', flexDirection: 'row', justifyContent: 'flex-start' }}>
            <Grid role="heading" sx={{
              color: '#1E1E1E',
              fontWeight: 'bold',
              fontSize: { xs: 15, sm: 'inherit' },
            }} >FinCEN Form 105</Grid>              
            <Grid role="heading" sx={{
              color: '#1E1E1E',
              fontWeight: 'bold',
              display: { xs: 'none', sm: 'block' },
            }} ><span>&nbsp;</span>| Currency and Monetary Instrument Report (CMIR)</Grid>
          </Grid>  
        </Grid>
        <Grid>
          <NavLink to="/help" target="help" rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
            <Grid container sx={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
              <img src={Needhelp} alt="needhelp" style={{cursor: 'pointer'}}/>
              <Button autoCapitalize="false" sx={{
                marginLeft: '0px',
                fontWeight: 'bold',
                color: '#3440E4',
                textDecoration: 'none',
                textTransform: 'none'
              }} align="center">Need Help?</Button>
            </Grid>
          </NavLink>
        </Grid>
      </Grid>

      <Grid container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Typography role="heading" sx={{
          color: '#003366',
          fontWeight: 'bold',
          margin: '16px 0 2px 24px',
          fontSize: {
            xs: '0.875rem',
            sm: '1.125rem',
            md: '1.5rem',
            lg: '1.875rem'
          },
        }} >Report of International Transportation of Currency or Monetary Instruments</Typography>
        <Typography role="heading" sx={{
          color: '#1E1E1E',
          fontWeight: 'bold',
          margin: '0px 0 32px 0',
          fontSize: {
            xs: '0.75rem',
            sm: '1rem',
            md: '1.375rem',
            lg: '1.75rem'
          },
        }} gutterBottom>Department of Treasury Financial Crimes Enforcement Network</Typography>
      </Grid>

      <Grid id="receiptPage" container sx={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>


        <Grid sx={{
          textAlign: 'left',
          justifyContent: 'center',
          color: 'text.primary',
          backgroundColor: '#cfcfcf',
          borderRadius: 3,
          width: { sm: 616, md: 616, lg: 796 },
          maxWidth: { xs: 410, sm: 'initial' },
          ml: { xs: 1.6, sm: 'auto' },
          mr: { xs: 1.6, sm: 'auto' },
        }} >
          <Grid container sx={{ pt: 2, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <Box component="img" sx={{
              height: { xs: '20px', sm: '36px' },
              width: { xs: '20px', sm: '36px' },
              mr: '0.5em',
            }} src={logo} alt="Green Check"/>
            <Typography role="heading" sx={{
              fontSize: { xs: '1.25rem', sm: '1.75rem' },
              fontWeight: 'bold',
            }} >Confirmation Receipt</Typography>
          </Grid>

          <Grid container sx={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <Typography role="heading" sx={{
              fontSize: { xs: '0.75rem', sm: '1rem' },
              pt: 1,
              pl: { xs: 1, sm: 0 },
            }}>Financial Crimes Enforcement Network (FinCEN) - Form 105</Typography>
          </Grid>

          <br/>

        
            
              <Grid container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>                  

                    <Grid sx={{
                      width: { xs: 320, sm: 544 },
                      textAlign: 'left',
                      justifyContent: 'center',
                      color: 'text.secondaryHeading',
                      backgroundColor: '#FFFFFF',
                      borderRadius: '15px',
                      overflowWrap: 'break-word',
                    }}>
                      {receipt.currencyTransporter === 'Y' &&
                      <Typography align='center' sx={{
                        fontSize: { xs: '0.75rem', sm: '1rem' },
                        pt: 1,
                        pl: { xs: 1, sm: 0 },
                      }} >Professional Currency Transporter</Typography>
                      }
                      {receipt.currencyTransporter === 'Y' &&
                      <Typography align='center'>(or) Armored Car Company</Typography>
                      }
                      {(receipt.workflow === 'M' && !receipt.currencyTransporter === 'Y') &&
                      <Typography align='left' style={{marginLeft: 160 + 'px', marginTop: 12 + 'px'}}>Mailed (or) Shipped</Typography>
                      }
                      
                      {receipt.business === '' &&
                      <Typography align='left' style={{marginLeft: 14 + 'px', marginTop: 12 + 'px', marginRight: 14 + 'px'}}>
                        {receipt.currencyTransporter === 'Y'? 'Personal Currency Carrier: ' : "Traveler's Name: "}<b>{receipt.firstName} {receipt.lastName}</b> 
                      </Typography>
                      }
                      {receipt.business !== '' && (
                      <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }} align='left' style={{marginLeft: 14 + 'px', marginTop: 12 + 'px'}}>
                        {receipt.currencyTransporter === 'Y'? 'Business Currency Carrier: ' : "Business Name: "}<b>{receipt.business}</b> 
                      </Typography>
                      )}
                      <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }} align='left' style={{marginLeft: 14 + 'px'}}>Confirmation Number: <b>{receipt.confirmationNumber}</b> </Typography>
                      
                      <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }} style={{marginLeft: 14 + 'px'}}>
                        <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>Total Amount (USD): 
                          <b><NumberFormat value={Math.round(receipt.totalUSD)} isNumericString={false} displayType={'text'} 
                              decimalScale={0} maximumfractiondigits={0} minimumfractiondigits= {0}  thousandSeparator={true} prefix={'$'} /></b>
                        </Typography>   
                      </Grid> 
                                                                  
                      <Typography sx={{ fontSize: { xs: '0.6875rem', sm: 'inherit' } }} align='left' style={{marginLeft: 14 + 'px'}} >Application Date and Time: <b>{receipt.submissionDate}</b></Typography>
                      <Typography sx={{ fontSize: { xs: '0.6875rem', sm: 'inherit' } }} align='left' style={{marginLeft: 14 + 'px', marginBottom: 12 + 'px'}} >Expiration Date and Time: <b>{receipt.expireDate}</b></Typography> 
                                              
                      {/* { <Grid container direction="row" justifyContent="flex-start" alignItems="center" style={{marginLeft: 14 + 'px', marginBottom: 14 + 'px'}}> */}
                        {/* <Typography style={{marginRight: 14 + 'px'}}>Please present this QR Code: </Typography> */}
                        {/* <QRCodeCanvas size='50' style={{height: 50 + 'px', width: 50 + 'px'}} value={receipt.confirmationNumber} /> */}
                      {/* </Grid>  } */}
                    
                    </Grid>
                
                    <Grid align='center' sx={{ width: { xs: 352, sm: 456 }, mt: 1, mb: 2.5 }}>
                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>Thank you for using eCMIR. This confirmation serves as the</Typography>
                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>receipt of your electronic monetary instrument report</Typography>
                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}> submission. Please be advised that this confirmation</Typography>
                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}><span style={{fontWeight: 'bold'}}>expires three days (72 hours) after submission.</span></Typography>
                       <br />

                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>You must arrive or depart the United States via a port of entry</Typography>
                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>within 72 hours; if you fail to do so, you will be required to</Typography>
                        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>complete a new FinCEN Form 105.</Typography>
                        <br />

                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>Kindly <span style={{fontWeight: 'bold'}}>save the confirmation number</span> as it must be</Typography>
                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>presented to a CBP Officer at the port of entry upon arrival or</Typography>
                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>departure from the United States.</Typography>
                       <br />

                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}> You can <span style={{fontWeight: 'bold'}}>Email, Print, or Download</span> the confirmation number by clicking the button below.</Typography>
                       <br />

                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>Please note, the submission of this provisional eCMIR</Typography>
                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>mandates that you present the confirmation number to a</Typography>
                       <Typography sx={{ fontSize: { xs: '0.75rem', sm: '0.9375rem' }, width: { xs: 352, sm: 'auto' } }}>CBP Officer at a Port of Entry to complete the process.</Typography>
                       {/* <Typography  className={classes.info2}>Please note, the submission of this provisional eCMIR mandates that</Typography>
                       <Typography className={classes.info2}>you present the confirmation number to a CBP Officer</Typography>
                       <Typography className={classes.info2}>at a Port of Entry to complete the process.</Typography> */}
                      <br />

                      <Typography>More information on U.S. ports of entry is available here:</Typography>

                      <Typography> <a target='ports' href={'https://www.cbp.gov/contact/ports'} sx={{ m: 1 }} underline="always" style={{color: '#1E1E1E'}}>
                        https://www.cbp.gov/contact/ports
                      </a></Typography>
                    </Grid>
                

              </Grid>
            
          
        </Grid>
      </Grid>

      <Grid container sx={{ height: { xs: 166, sm: 100 }, mt: { xs: 2, sm: 0 }, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        <Popup trigger={<Button variant="outlined" color="primary" onClick={() => startOver()} sx={{ color: "#324bb5", borderColor: "#324bb5", ml: 1, mr: 1, width: 200, mb: { xs: 1, sm: 0 } }}>New Application</Button>}
          modal closeOnDocumentClick>
          {close => (
            <Grid sx={{ fontSize: '1rem', backgroundColor: 'white', borderRadius: 10 }}>
                {/* eslint-disable-next-line */}
              <a sx={{
                cursor: 'pointer',
                display: 'block',
                lineHeight: '1.25rem',
                fontSize: '1.375rem',
                backgroundColor: '#ffffff00',
                position: 'absolute',
                padding: '2px 5px',
                right: '0px',
                top: '-1px',
              }} onClick={close}>
                &times;
              </a>
              <Grid sx={{ fontSize: '1.5rem', textAlign: 'center' }}>Are you sure you want to leave the receipt page?</Grid>
              <hr/>
              <Grid sx={{ mb: 3, fontSize: '1rem' }}>Your receipt will not be saved</Grid>
              <br/>
              <Grid>
                <Button variant="outlined" color="secondary" onClick={() => {close()}} sx={outlinedButtonSx}>Back to Receipt</Button>
                <Button variant="contained" color="primary" onClick={() => startOver()} sx={containedButtonSx}>New Application</Button>
              </Grid>
            </Grid>
          )}
        </Popup>

        <Popup trigger = {<Button id="emailBtn" variant="contained" color="primary" sx={containedButtonSx}>Email</Button>} 
          modal closeOnDocumentClick >
          {close => ( 
            <Grid sx={{ fontSize: '1rem', backgroundColor: 'white', borderRadius: 10 }}>
              {/* eslint-disable-next-line */}
              <a sx={{
                cursor: 'pointer',
                display: 'block',
                lineHeight: '1.25rem',
                fontSize: '1.375rem',
                backgroundColor: '#ffffff00',
                position: 'absolute',
                padding: '2px 5px',
                right: '0px',
                top: '-1px',
              }} onClick={close}>
                &times;
              </a>
              <Grid sx={{ fontSize: '1.5rem', textAlign: 'center' }}>Email the Confirmation Receipt</Grid>
              <hr/>
              {modalopen === true && <Grid container sx={{ mb: 3, fontSize: '1rem', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                  <TextField
                      autoFocus
                      id="email"
                      label="Email Address"
                      sx={{ width: 408 }}
                      placeholder="youremail@domain.com"
                      helperText={errorText}
                      value={email}
                      onChange={handleChange}
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                  />
              </Grid>
              }
              {modalopen === false &&
                <Grid  container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}> 
                  <Typography>Confirmation Email send to</Typography>
                  <Typography>{email}</Typography>
                </Grid>
              }
              
              <Grid  container sx={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Button variant="outlined" color="secondary" onClick={() => { modalOpen(); close(); }} 
                              sx={outlinedButtonSx}>{modalopen === true? 'Cancel' : 'Close'}</Button>
                {modalopen === true && <Button variant="contained" color="primary"  disabled= {isValidEmail?false:true} onClick={() => {emailConfirmation()} } sx={containedButtonSx}>Send</Button>}
              </Grid>
            </Grid>
          )}
        </Popup>

        <Button variant="contained" color="primary" onClick={() => printReceipt()} sx={containedButtonSx}>
          Print
        </Button>

        <Button variant="contained" color="primary" onClick={() => downloadPDF()} sx={containedButtonSx}>
          Download
        </Button>
      </Grid>
      {/* </center> */}
    </Grid>
  );
}

export default Confirmation;
